import { useCallback, useEffect, useState } from 'react';
import { GridDensity, GridState } from "@mui/x-data-grid-pro";
import { SetPreferenceSignature } from 'hooks/preferences';
import { IDashboardSettings } from 'components/preferences';

type GridDensityChangeHandler = (state: GridDensity) => void;

type UseDensityHandlerProps = {
    settings: IDashboardSettings | null,
    setSettings: SetPreferenceSignature
};

type UseDensityHandlerResult = [
    GridDensity,
    GridDensityChangeHandler
];

const useDensityHandler: (props: UseDensityHandlerProps) => UseDensityHandlerResult = (props: UseDensityHandlerProps) => {
    const { settings, setSettings } = props;
    const [ density, setDensity ] = useState<GridDensity>('standard');
    const [ _lastDensity, _setLastDensity ] = useState<GridDensity>('standard');

    const persistDensity = (newDensity: GridDensity) => {
        if (settings) {
            setSettings({
                ...settings,
                columnDensity: newDensity
            });
        }
    }
    
    useEffect(() => {
        if (settings) {
            setDensity(settings.columnDensity as GridDensity);
        }
    }, [ settings ]);

    const handleDensityChange: GridDensityChangeHandler = useCallback(
        (newDensity: GridDensity) => {
            if (_lastDensity !== newDensity) {
                _setLastDensity(newDensity);
            } else {
                return;
            }

            if (settings === null) return;
            if (density === null) return;
            
            if (settings.columnDensity === density && density != newDensity) {
                console.log(`${density} => ${newDensity}`);
                persistDensity(newDensity);
            }
        },
        [ settings, density, _lastDensity ]
    );

    return [
        density,
        handleDensityChange
    ]
}

export default useDensityHandler;